import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117a6768"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["to"]
const _hoisted_2 = {
  key: 1,
  class: "tag text-decoration-none position-relative bg-white rounded-pill px-3"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-red position-absolute" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { PropType, ref, onMounted, nextTick } from 'vue'
import { Tag } from '@/layouts/aside/index.vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  tag: Object as PropType<Tag>,
  editable: Boolean,
  removeTag: {
    type: Function as PropType<() => void | undefined>,
  },
  searchable: {
    type: Boolean,
    default: false,
  },
  wideTextInput: {
    type: Boolean,
    default: false,
  },
},
  emits: ['editTag'],
  setup(__props, { emit }) {

const props = __props



const isEdit = ref<boolean>(false)
const route = useRoute()
const tagTitle = ref<string>(props.tag?.name)
const currentTag = ref<number>()

const setEdit = (): void => {
  if (!props.editable) return
  isEdit.value = !isEdit.value
}



//2022/12/05 NAMPH7425 Fix for UAT#5352: CT10  (Ph2-R20221222)
onMounted(() => {
  const modalEdit = document.querySelector('#modalEdit')
  if (modalEdit) {
    modalEdit.addEventListener('hidden.bs.modal', function () {
      isEdit.value = false
      tagTitle.value = props.tag?.name
    })
  }
})
//2022/12/05 NAMPH7425 Fix for UAT#5352: CT10  (Ph2-R20221222)

const formatTag = (name: string): string => {
  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  let tag = trimmedArray.length ? trimmedArray[0] : ''

  if (tag.length > 20) {
    tag = tag.substring(0, 20)
  }

  return tag
}

const handleEdit = (): void => {
  emit('editTag', props.tag.id, tagTitle.value)
  const tag = formatTag(tagTitle.value)
  nextTick(() => {
    if (!tag) {
      props.removeTag()
    }

    tagTitle.value = tag
  })
  setEdit()
}

return (_ctx: any,_cache: any) => {
  return (__props.searchable)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        to: {
      path: _unref(route).path,
      // query: { ...route.query, tags: tag.name },
    },
        onClick: _cache[0] || (_cache[0] = () => (currentTag.value = __props.tag.name)),
        class: _normalizeClass([
      // route.query?.tags === tag.name || currentTag === tag.name ? 'active' : '',
      'tag fs-8 text-decoration-none position-relative  bg-white rounded-pill px-3',
    ])
      }, [
        _createElementVNode("span", null, _toDisplayString(__props.tag.name), 1)
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (!isEdit.value)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: "tag-edit",
              class: _normalizeClass([__props.editable ? 'me-2' : '', 'fs-8']),
              onClick: _withModifiers(setEdit, ["self"])
            }, _toDisplayString(__props.tag.name), 11, _hoisted_3))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: _normalizeClass([__props.wideTextInput ? 'wide-tag-edit' : '', "border-0"]),
              id: "tag-edit",
              maxlength: "20",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tagTitle).value = $event)),
              onKeypress: [
                _cache[2] || (_cache[2] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
                _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => ($event.target.blur()), ["prevent"]), ["space"]))
              ],
              onBlur: handleEdit
            }, null, 34)), [
              [_vModelText, tagTitle.value]
            ]),
        (__props.editable)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (__props.removeTag()))
            }, _hoisted_5))
          : _createCommentVNode("", true)
      ]))
}
}

})